module.exports = "https://activity.hdslb.com/blackboard/activity92636/img/loading.1434e676.png";